var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("redeem_success_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('redeem_success_page.form_desc'))
    }
  }), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading ? _c('div', [_c('div', {
    staticClass: "p-4 shadow-lg rounded redeem--content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('redeem_success_page.content'))
    }
  })]) : _vm._e()], 1), _vm.getModuleConfig('redeem_success_page.button_text') || _vm.getModuleConfig('redeem_success_page.cancel_button_text') ? _c('div', {
    staticClass: "p-3 fixed-bottom bg-white footer"
  }, [_c('MemberButton', {
    attrs: {
      "button-text": _vm.getModuleConfig('redeem_success_page.button_text'),
      "button-url": _vm.getModuleConfig('redeem_success_page.button_url'),
      "type": _vm.getModuleConfig('redeem_success_page.button_action')
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }